document.addEventListener('DOMContentLoaded', function() {

  // Define the element where the pill will be displayed
  var pillContainer = document.getElementById('product-condition-pill');

  // Check the metafield value and display the appropriate pill
  if (isProductNew === 'true') {
    pillContainer.innerHTML = '<span class="condition-pill new-condition">New</span>';
  } else if (isProductNew === 'false') {
    pillContainer.innerHTML = '<span class="condition-pill pre-owned-condition">Semi-nuevo</span>';
  }
});
